import { ChromatogramSeries } from "./chromatogram_series.js";
export class ChromatogramSeries2D extends ChromatogramSeries {
    constructor(array, options) {
        super(array, 2, options);
    }
    dataToJson() {
        return this.getData().map(([masses, intensities]) => [
            Array.from(masses),
            Array.from(intensities),
        ]);
    }
}
//# sourceMappingURL=chromatogram_series_2d.js.map